import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { BreadCrumbs } from '../../Layout/Header/BreadCrumbs';

import { AddRecord } from '@components/ActionButtons';
import { BoxBodyContainer, BoxHeaderTitle } from '@components/Box';
import { BreadcrumbsContainer } from '@components/BreadcrumbsContainer';
import { GridHeaderMenuTitle } from '@components/HeaderTitle';
import { routes } from '@config/routes';

export const Invoice = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const baseBreadCrumbs = [{ link: 'Revenue and Collections', to: '' }];

  const isOnHomePage = location.pathname === routes.RNC_INVOICES;

  const breadCrumbLinks = isOnHomePage
    ? baseBreadCrumbs
    : [...baseBreadCrumbs, { link: 'Invoice', to: routes.RNC_INVOICES }];

  return (
    <>
      <div className="p-4 space-y-4">
        <BreadcrumbsContainer>
          <div className="lg:text-sm md:text-sm text-xs text-gray-500">
            Revenue and Collections
          </div>
          <div className="lg:flex md:flex hidden">
            <BreadCrumbs links={breadCrumbLinks} />
          </div>
        </BreadcrumbsContainer>

        <div>
          <div className="flex justify-between items-center space-x-5">
            <BoxHeaderTitle>
              <GridHeaderMenuTitle>
                <div className="lg:text-2xl md:text-xl text-sm lg:font-black md:font-black font-bold">
                  Invoices
                </div>
              </GridHeaderMenuTitle>
            </BoxHeaderTitle>

            <div className="">
              {isOnHomePage && (
                <div className="flex flex-row space-x-1">
                  <AddRecord
                    label="Create Invoice"
                    onClick={() => {
                      navigate(`${routes.RNC_INVOICES}/create`);
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="p-4 bg-white rounded-b-xl rounded-tr-xl">
            <BoxBodyContainer>
              <Outlet />
            </BoxBodyContainer>
          </div>
        </div>
      </div>
    </>
  );
};
